export const createClrs = (data) => async (dispatch, getState) => {
  dispatch({ type: "create", payload: data });
};
